import { ArrowUpRight } from "lucide-react";

const QUICK_LINKS = [
  { label: "Home", href: "#hero" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Results", href: "#stats" },
  { label: "Contact", href: "#contact" },
];

const handleJump = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 bg-black"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-24">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3">
              <span className="relative inline-flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-[#FF7B00] to-[#FF9933] text-black font-display font-black">
                M
                <span className="absolute -right-1 -bottom-1 h-2.5 w-2.5 rounded-sm bg-[#FFB347] border border-black" />
              </span>
              <span className="font-display text-xl font-bold">
                Mature Marketing &amp; Services
              </span>
            </div>
            <p className="mt-6 max-w-md text-zinc-400 leading-relaxed">
              A performance-first studio for brands that want compounding
              growth, sharp creative, and reliable delivery — across every
              channel that matters.
            </p>
            <button
              data-testid="footer-cta"
              onClick={() => handleJump("#contact")}
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#FF7B00] to-[#FF9933] px-6 py-3 text-sm font-bold text-black hover:scale-[1.03] transition-transform"
            >
              Start a project <ArrowUpRight className="h-4 w-4" strokeWidth={2.25} />
            </button>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#FF7B00] mb-5">
              Quick Links
            </div>
            <ul className="space-y-3">
              {QUICK_LINKS.map((q) => (
                <li key={q.href}>
                  <button
                    data-testid={`footer-link-${q.label.toLowerCase().replace(/\s/g, "-")}`}
                    onClick={() => handleJump(q.href)}
                    className="text-zinc-300 hover:text-[#FF7B00] transition-colors"
                  >
                    {q.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#FF7B00] mb-5">
              Reach Us
            </div>
            <ul className="space-y-3 text-zinc-300">
              <li>
                <a
                  href="tel:+918853623126"
                  className="hover:text-[#FF7B00] transition-colors"
                  data-testid="footer-phone"
                >
                  88536 23126
                </a>
              </li>
              <li>
                <a
                  href="mailto:sales@maturemspl.store"
                  className="hover:text-[#FF7B00] transition-colors break-all"
                  data-testid="footer-email"
                >
                  sales@maturemspl.store
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Massive brand mark */}
        <div className="mt-16 select-none pointer-events-none">
          <div className="font-display text-[18vw] lg:text-[12vw] leading-none font-black tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-white/10 to-white/[0.02]">
            MATURE.
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-zinc-500">
          <div>
            © {year} Mature Marketing &amp; Services PVT LTD. All rights reserved.
          </div>
          <div className="flex items-center gap-4">
            <span>Growth • Branding • Lead Generation</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
